import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Card,
    Dropdown,
    FormControl,
    IconButton,
    Menu,
    MenuButton,
    MenuItem,
    Option,
    Select,
    Table,
    Typography,
  } from '@mui/joy';
  import React, { useEffect, useState } from 'react';
  import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
  import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { post, Token } from '../../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import MoreVert from '@mui/icons-material/MoreVert';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
  function VerwantwortlichenEditor({ data, upd }) {
    const [createver, setcreatever] = useState(false);
    const [currentrole, setcurrentrole] = useState('');
    const [currentrights, setcurrentrights] = useState('');
    const [users, setusers] = useState([]);
    const [selecteduser, setselecteduser] = useState(null);
    const [alert, setalert] = useState(false);
    const [editmode, seteditmode] = useState(false);
    const [currentedited, setcurrentedit] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchVereinData = async () => {
        const body = {
            token: Token.get(),
            action: "get_users",
            target: data.id,
        };

        try {
            let response = await post(body, "/vergleiche/sub-sparten");
            if (response === "LOGOUT") {
            navigate("/");
            return;
            }
            setusers(JSON.parse(response).users);
            console.log(response);
        } catch (error) {
            console.error("Error fetching data:", error);
        } 
        };

        setTimeout(() => {
        fetchVereinData(); 
        }, 100); 
    }, [navigate]);
    function add_verantwortlichen(){
        let body = {};
        body.token = Token.get();
        body.target = data.id;
        body.action = !editmode ? "add_verwantwortlichen" : "edit_verantwortlichen";
        body.bzh = currentrole;
        body.targetid = currentedited != null ? currentedited : selecteduser.id;
        body.editrights = currentrights;
        let response = post(body, "/vergleiche/sub-sparten");
        if (response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            upd();
            setcreatever(false);
            setalert(true);
            setcurrentedit(null);
        }
    }
    function delete_verwantwortlichen(a) {
        let body = {};
        body.token = Token.get();
        body.target = data.id;
        body.action = "remove_verantwortlichen"
        body.targetid = a;
        let response = post(body, "/vergleiche/sub-sparten");
        if (response == "LOGOUT"){
            navigate("/");
        }
        if (response == "OK"){
            upd();
            setcreatever(false);
            setalert(true);
        }
    }

    return (
      <>
        <Card
          variant="soft"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            mb: 4,
          }}
        >
          <Box>
            <Typography level="title-md">Verantwortlichen Hinzufügen</Typography>
            <Typography>Füge einen Verwantwortlichen hinzu</Typography>
          </Box>
          <Button
            sx={{ height: '5%', mt: 1 }}
            startDecorator={<AddBoxOutlinedIcon />}
            onClick={() => {setcreatever(!createver); seteditmode(false); setcurrentedit(null)}}
          >
            Erstellen
          </Button>
        </Card>
  
        {createver && (
          <Card
            variant="soft"
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row',
              mb: 4,
            }}
          >
            <Box sx={{ width: '20%' }}>
              <Typography level="title-md">{editmode ? ("Verantwortlichen bearbeiten") : ("Verantwortlichen Hinzufügen")}</Typography>
              {
                !editmode && (
                    <>
                    <Typography>Nutzer auswählen</Typography>
                    <Autocomplete 
                    options={users}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, newValue) => setselecteduser(newValue)}
                    />
                    </>
                )

              }
              <Typography sx={{ mt: 2 }}>Rolle auswählen</Typography>
              <FormControl fullWidth>
                <Select
                  value={currentrole}
                  onChange={(e, newValue) => setcurrentrole(newValue)}
                  placeholder="Rolle wählen"
                >
                  <Option value="Konzeptbetreuer">Konzeptbetreuer</Option>
                  <Option value="Leistungsvergleichsbeauftragter">Leistungsvergleichsbeauftragter</Option>
                  <Option value="Sonderbeauftragter">Sonderbeauftragter</Option>
                  <Option value="Spartenbetreuer">Spartenbetreuer</Option>
                </Select>
              </FormControl>
  
              <Typography sx={{ mt: 2 }}>Berechtigung auswählen</Typography>
              <FormControl fullWidth>
                <Select
                  value={currentrights}
                  onChange={(e, newValue) => setcurrentrights(newValue)}
                  placeholder="Berechtigung wählen"
                >
                  <Option value={true}>Ja, Bearbeitungsrechte erteilen</Option>
                  <Option value={false}>Nein, keine Bearbeitungsrechte</Option>
                </Select>
              </FormControl>
  
              <Button
                sx={{ height: '5%', mt: 2 }}
                startDecorator={<SaveOutlinedIcon />}
                onClick={() =>
                    add_verantwortlichen()
                }
              >
                Speichern
              </Button>
            </Box>
          </Card>
        )}
                {
                    alert && (
                        <Alert
                        sx={{mb: 5}}
                        variant="soft"
                        color="success"
                        startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                        endDecorator={
                            <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                            Schliesen
                            </Button>
                        }
                        >
                        Ihre änderungen wurden Erfolgreich gespeichert.
                        </Alert>
                    )
                }
        <Card
            variant="soft">
            <Table sx={{ '& thead th:nth-child(1)': { width: '35%' } }}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Rolle</th>
                  <th>Bearbeiten</th>
                </tr>
               </thead>
              <tbody>
                {data.Verantwortliche.map((item) => (
                  <tr key={item.name}>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>{item.bezeichnung}</td>
                    <td>
                        <Dropdown>
                                <MenuButton
                                slots={{ root: IconButton }}
                                slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                >
                                <MoreVert />
                                </MenuButton>
                                <Menu>
                                <MenuItem onClick={() => {seteditmode(true); setcurrentedit(item.id); setcreatever(true)}}>Verantwortlichen Bearbeiten</MenuItem>
                                <MenuItem sx={{color:"red"}} onClick={() => {delete_verwantwortlichen(item.id)}} >Verantwortlichen löschen</MenuItem>
                            </Menu>
                        </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>












            </Card>


      </>
    );
  }
  
  export default VerwantwortlichenEditor;
  